import React, { useState } from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";
import axios from "axios";
import { isNumber, url } from "../../lib/Common";

const useStyles = makeStyles({
  TextField: {
    marginTop: 10,
    marginBottom: 10,
  },
  TextLabel: {
    fontWeight: "bold",
    color: "black",
  },
});

function Phone({ setBlurFlag, formRef, phoneRef, onChangePhone, phone }) {
  const classes = useStyles();
  const [errorText, setErrorText] = useState(
    "휴대폰번호(숫자만 연속해서입력, 예: 01011112222) 입력하세요."
  );
  const [errorValue, setErrorValue] = useState(false);

  const validatePhone = async (inputPhone) => {
    const urlCheck = url + "/api/specialMember/phoneCheck";
    try {
      const response = await axios.post(
        urlCheck,
        {
          phone: inputPhone,
        },
        { withCredentials: true }
      );
      if (response.data.COUNT === "0") {
        setErrorText("해당 휴대폰번호는 존재하지 않습니다.");
        setErrorValue(true);
      } else {
        setErrorText("");
        setErrorValue(false);
        onChangePhone(inputPhone);
        setBlurFlag(true);
        const form = formRef.current;
        if (form) {
          if (typeof form.requestSubmit === "function") {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event("submit", { cancelable: true }));
          }
        }
      }
    } catch (e) {
      setErrorText("서버 호출 에러");
      setErrorValue(true);
    }
    return;
  };

  const handlePhoneValidate = (value) => {
    if (!isNumber.test(value) || (value.length <= 9 && value.length >= 1)) {
      setErrorText(
        "휴대폰번호(숫자만 연속해서입력, 예: 01011112222) 입력하세요."
      );
      setErrorValue(true);
      phoneRef.current.focus();
    } else {
      validatePhone(value);
    }
  };
  return (
    <TextField
      className={classes.TextField}
      required
      fullWidth
      inputRef={phoneRef}
      error={errorValue}
      helperText={errorText}
      label="휴대폰번호(Phone)"
      type="text"
      variant="filled"
      inputProps={{
        maxLength: 11,
      }}
      InputLabelProps={{
        className: classes.TextLabel,
      }}
      FormHelperTextProps={{ className: classes.TextLabel }}
      onKeyPress={(e) => {
        if (e.key === "Enter") {
          handlePhoneValidate(e.target.value);
        }
      }}
      onBlur={(e) => {
        handlePhoneValidate(e.target.value);
      }}
      name="phone"
      defaultValue={phone}
    />
  );
}
Phone.propTypes = {
  setBlurFlag: PropTypes.func,
  formRef: PropTypes.object,
  blurFlag: PropTypes.bool,
  phone: PropTypes.string,
  onChangePhone: PropTypes.func,
  phoneRef: PropTypes.object,
};
export default Phone;
